export const worshipTime = {
	GET_WORSHIP_TIME: "worship/time/get",
	ADD_WORSHIP_TIME: "worship/time/add",
	UPDATE_WORSHIP_TIME: "worship/time/update",
	DELETE_WORSHIP_TIME: "worship/time/delete",
}

export default worshipTime
